import React, { useEffect, useState, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";


function OpdReports() {
  // helper date/format functions (unchanged)
  function parseServerDate(datetimeStr) {
    if (!datetimeStr) return null;
    const cleaned = String(datetimeStr).replace("T", " ").trim();
    const [datePart, timePart] = cleaned.split(" ");
    const [year, month, day] = (datePart || "").split("-").map((n) => parseInt(n, 10));
    if (!year || !month || !day) return null;
    let hours = 0, minutes = 0, seconds = 0;
    if (timePart) {
      const parts = timePart.split(":").map((n) => parseInt(n, 10));
      hours = Number.isFinite(parts[0]) ? parts[0] : 0;
      minutes = Number.isFinite(parts[1]) ? parts[1] : 0;
      seconds = Number.isFinite(parts[2]) ? parts[2] : 0;
    }
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }
  function formatDateTime12h(dateObj) {
    if (!dateObj) return "";
    const d = dateObj;
    const day = String(d.getDate()).padStart(2, "0");
    const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day} ${month} - ${year} ${String(hours).padStart(2,"0")}:${minutes} ${ampm}`;
  }
  function classifyMode(raw) {
    if (!raw) return "";
    const s = String(raw).toLowerCase();
    if (s.includes("cash")) return "cash";
    if (s.includes("card") || s.includes("credit") || s.includes("debit") || s.includes("swipe")) return "card";
    if (s.includes("online") || s.includes("upi") || s.includes("gateway") || s.includes("net")) return "online";
    return "";
  }
  function mapPayMode(raw) {
    if (!raw) return "";
    const s = String(raw).trim().toLowerCase();
    if (s.includes("cash")) return "Cash";
    if (s.includes("card") || s.includes("credit") || s.includes("debit") || s.includes("swipe")) return "Card";
    if (s.includes("online") || s.includes("upi") || s.includes("gateway") || s.includes("net")) return "Online";
    return raw;
  }

  const today = (() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  })();

  // state
  const [formData, setFormData] = useState({
    l1: [],
    docs: [],
    users: [],
    from: today,
    to: today,
    search_key: "",
    selectedDoctorId: "",
    selectedUserId: ""
  });

  const [masterList, setMasterList] = useState([]);
  const [paymentsList, setPaymentsList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [doctorsMap, setDoctorsMap] = useState({});
  const [summary, setSummary] = useState({ totalReports: 0, totalAmount: 0, todaysCollection: 0, collectionBy: { cash:0, card:0, online:0 } });
  const [totals, setTotals] = useState({
    totalAmount: 0,
    paidAmount: 0,
    dueAmount: 0,
    totalRows: 0,
    cashTotal: 0,
    cardTotal: 0,
    onlineTotal: 0,
    registrationCharges: 0,
    doctorFees: 0,
    // Procedure bill totals
    procBillAmount: 0,
    procBillCash: 0,
    procBillCard: 0,
    procBillOnline: 0
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  // ----- lookups -----
  function getDoctorNameById(id, fallbackName) {
    if (fallbackName && String(fallbackName).trim() !== "") return String(fallbackName).trim();
    if (id !== undefined && id !== null && String(id).trim() !== "") {
      const key = String(id).trim();
      if (doctorsMap && typeof doctorsMap === 'object') {
        if (doctorsMap[key]) return doctorsMap[key];
        if (!isNaN(Number(key)) && doctorsMap[String(Number(key))]) return doctorsMap[String(Number(key))];
        if (doctorsMap[key.toLowerCase()]) return doctorsMap[key.toLowerCase()];
      }
    }
    const docsArray = Array.isArray(formData.docs) ? formData.docs : (Array.isArray(formData.doc) ? formData.doc : []);
    if (id !== undefined && id !== null && String(id).trim() !== "") {
      const strId = String(id).trim();
      const doctorById = docsArray.find(d => {
        if (!d) return false;
        const candidates = [
          d.user_id, d.id, d.userId, d.emp_id, d.uid, d.doctor_id,
          d.doc?.doc_parent, d.doc?.doc_user, d.doc?.doc_id, d.doc_parent
        ].filter(Boolean);
        return candidates.some(c => String(c).trim() === strId);
      });
      if (doctorById) {
        const name = (doctorById.fname || doctorById.name || doctorById.full_name || '').trim();
        const degree = (doctorById.doc && (doctorById.doc.doc_degree || doctorById.doc.doc_specality)) || '';
        return degree ? `${name} (${degree})` : (name || `Doctor #${strId}`);
      }
    }
    if (id && isNaN(Number(String(id).trim()))) return String(id).trim();
    if (fallbackName) return fallbackName;
    if (id !== undefined && id !== null && String(id).trim() !== "") return `Doctor #${String(id).trim()}`;
    return 'N/A';
  }

  function getUserNameById(id) {
    if (!id && id !== 0) return "";
    const found = usersList.find(u => String(u.user_id) === String(id) || String(u.id) === String(id));
    if (found) return found.name || found.fname || found.username || `User#${id}`;
    return `User#${id}`;
  }

  // ----- fetch doctors & users -----
  const fetchDoctors = async () => {
    try {
      const fd = new FormData();
      fd.append("type", "doctor");
      fd.append("page_no", "none");
      const res = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd);
      if (res?.data?.status && Array.isArray(res.data.records)) {
        const docs = res.data.records;
        setFormData(prev => ({ ...prev, docs }));
        const map = {};
        docs.forEach(d => {
          const display = (d.fname || d.name || d.full_name || (d.doc && (d.doc.doc_name || '')) || d.username || "").toString().trim();
          const displayWithExtra = (() => {
            const deg = d.doc?.doc_degree ?? d.doc?.doc_specality ?? "";
            return deg ? (display ? `${display} (${deg})` : String(display)) : (display || "");
          })();
          const keys = [
            d.user_id, d.id, d.userId, d.emp_id, d.uid, d.doctor_id, d.doctorId,
            d.doc?.doc_parent, d.doc?.doc_user, d.doc?.doc_id, d.doc_parent
          ];
          keys.forEach(k => {
            if (k !== undefined && k !== null && String(k).trim() !== "") {
              map[String(k).trim()] = displayWithExtra || display || String(k);
            }
          });
          if (display) map[display.toLowerCase()] = displayWithExtra || display;
        });
        setDoctorsMap(map);
      }
    } catch (err) {
      console.warn("fetchDoctors", err);
    }
  };

  const fetchUsersForFilter = async () => {
    try {
      const fd = new FormData();
      fd.append("page_no", "none");
      const res = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd);
      if (res?.data?.status && Array.isArray(res.data.records)) {
        const mapped = res.data.records.map(u => ({
          user_id: u.user_id ?? u.id ?? u.userId,
          name: (u.fname || u.name || u.username || (`${u.user_id ?? u.id}`))
        }));
        setUsersList(mapped);
      }
    } catch (err) {
      console.warn("fetchUsersForFilter", err);
    }
  };

  // ----- main fetch -----
  const initData = async () => {
    try {
      const fd = new FormData();
      fd.append("page_no", "none");
      if (formData.search_key) fd.append("search_key", formData.search_key);
      if (formData.from) fd.append("from", `${formData.from} 00:00:00`);
      if (formData.to) fd.append("to", `${formData.to} 23:59:59`);
      if (formData.selectedDoctorId) fd.append("doctor_id", String(formData.selectedDoctorId));
      if (formData.selectedUserId) fd.append("user_id", String(formData.selectedUserId));

      const resp = await axios.post(AppConst.BASE_URL + AppConst.getOpdListUrl, fd, { headers: { 'Content-Type':'multipart/form-data' }});
      if (resp?.data?.status && Array.isArray(resp.data.records)) {
        const records = resp.data.records;

        records.forEach(r => {
          r.opd_reg_fees = Number(r.opd_reg_fees ?? r.opd_reg_fee ?? r.opd_reg_charge ?? 0);
          r.opd_final_amt = Number(r.opd_final_amt ?? r.opd_total ?? 0);
          r.opd_fees = Number(r.opd_fees ?? r.opd_doc_comm ?? r.opd_doc_fee ?? 0);
          r.opd_paid = Number(r.opd_paid ?? 0);
        });

        setMasterList(records);

        setDoctorsMap(prev => {
          const copy = { ...(prev || {}) };
          records.forEach(r => {
            const idCandidates = [
              r.opd_concult_doctor, r.opd_refer_doctor, r.doctor_id, r.doctorId, r.opd_doc_id
            ].filter(x => x !== undefined && x !== null && String(x).trim() !== "");
            const nameCandidates = [
              r.consult_doctor_name, r.opd_concult_doctor_name, r.opd_refer_doctor_name,
              r.doctor_name, r.opd_doc_name, r.doctor, r.refer_doctor
            ].filter(Boolean).map(x => String(x).trim()).filter(x=>x!=="");
            if (nameCandidates.length > 0) {
              const pick = nameCandidates[0];
              idCandidates.forEach(k => { copy[String(k).trim()] = pick; });
              copy[pick.toLowerCase()] = pick;
            } else {
              const raw = r.opd_concult_doctor;
              if (raw && isNaN(Number(raw))) {
                copy[String(raw).trim()] = String(raw).trim();
                copy[String(raw).trim().toLowerCase()] = String(raw).trim();
              }
            }
          });
          return copy;
        });

        const userMapLocal = {};
        records.forEach(r => {
          const uid = r.last_used_id ?? r.opd_user ?? r.user_id ?? null;
          const nameFromRow = r.user_display ?? r.last_used ?? r.fname ?? r.username ?? null;
          if (uid && nameFromRow) userMapLocal[String(uid)] = nameFromRow;
        });
        setUsersList(prev => {
          const existing = prev.reduce((acc, u) => { acc[String(u.user_id)] = u.name; return acc; }, {});
          Object.keys(userMapLocal).forEach(k => { if (!existing[k]) existing[k] = userMapLocal[k]; });
          return Object.keys(existing).map(k => ({ user_id: k, name: existing[k] }));
        });

        let totalAmount = 0;
        let todaysCollection = 0;
        let cashToday = 0, cardToday = 0, onlineToday = 0;
        const localToday = today;
        records.forEach(r => {
          totalAmount += Number(r.opd_final_amt ?? 0);
          const regDt = parseServerDate(r.opd_reg_datetime ?? r.opd_reg_date ?? r.opd_datetime ?? r.created_at ?? r.reg_datetime_display ?? "");
          const regYMD = regDt ? `${regDt.getFullYear()}-${String(regDt.getMonth()+1).padStart(2,'0')}-${String(regDt.getDate()).padStart(2,'0')}` : "";
          if (regYMD === localToday && Number(r.opd_paid ?? 0) > 0) {
            const paid = Number(r.opd_paid ?? 0);
            todaysCollection += paid;
            const pm = classifyMode(r.opd_mode ?? r.opd_pay_mode ?? r.opd_payment_mode ?? "");
            if (pm === "cash") cashToday += paid;
            else if (pm === "card") cardToday += paid;
            else if (pm === "online") onlineToday += paid;
            else cashToday += paid;
          }
        });

        setSummary({
          totalReports: records.length,
          totalAmount,
          todaysCollection,
          collectionBy: { cash: cashToday, card: cardToday, online: onlineToday }
        });

        const payments = records
          .filter(r => Number(r.opd_due_pay_amount ?? 0) > 0 && (r.opd_due_pay_date || r.opd_due_date))
          .map(r => ({
            opd_reg_id: r.opd_id,
            opd_uhid: r.opd_uhid,
            opd_name: r.opd_patient_name,
            opd_due_pay_mode: r.opd_due_pay_mode || r.opd_due_mode || '',
            opd_due_pay_date: r.opd_due_pay_date || r.opd_due_date || '',
            opd_due_pay_amount: Number(r.opd_due_pay_amount ?? 0),
            opd_due_pay_user: r.opd_due_pay_user || r.last_used || r.fname || '',
            __sourceRow: r
          }));

        const fromDate = formData.from ? new Date(`${formData.from}T00:00:00`) : null;
        const toDate = formData.to ? new Date(`${formData.to}T23:59:59`) : null;
        const paymentsFiltered = payments.filter(p => {
          if (!p.opd_due_pay_date) return false;
          const pd = parseServerDate(p.opd_due_pay_date);
          if (!pd) return false;
          if (fromDate && pd < fromDate) return false;
          if (toDate && pd > toDate) return false;
          return true;
        });

        setPaymentsList(paymentsFiltered);

      } else {
        setMasterList([]);
        setPaymentsList([]);
        setSummary({ totalReports: 0, totalAmount: 0, todaysCollection: 0, collectionBy:{cash:0,card:0,online:0}});
        setTotals({
          totalAmount: 0, paidAmount:0, dueAmount:0, totalRows:0,
          cashTotal:0, cardTotal:0, onlineTotal:0, registrationCharges:0, doctorFees:0,
          procBillAmount:0, procBillCash:0, procBillCard:0, procBillOnline:0
        });
        if (resp?.data && resp.data.message) toast.info(resp.data.message);
      }
    } catch (err) {
      console.error("initData error:", err);
      toast.error("Failed to fetch OPD data.");
    }
  };

  useEffect(() => {
    fetchDoctors();
    fetchUsersForFilter();
    initData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const t = setTimeout(() => initData(), 160);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [formData.from, formData.to, formData.search_key, formData.selectedDoctorId, formData.selectedUserId]);

  // ----- grouping -----
  const groupByUHID = (records) => {
    const grouped = {};
    records.forEach(r => {
      const uhid = r.opd_uhid || `UHID_${r.opd_id || Math.random()}`;
      const paid = Number(r.opd_paid ?? 0);
      const finalAmt = Number(r.opd_final_amt ?? r.opd_total ?? 0);
      const regFee = Number(r.opd_reg_fees ?? r.opd_reg_fee ?? r.opd_reg_charge ?? 0);
      const drFee = Number(r.opd_fees ?? r.opd_doc_comm ?? r.opd_doc_fee ?? 0);
      const regDatetimeSample = r.reg_datetime_display ?? r.opd_reg_datetime ?? r.opd_reg_date ?? r.opd_datetime ?? r.created_at ?? "";
      const userDisplaySample = (r.user_display && String(r.user_display).trim()) || (r.last_used && String(r.last_used).trim()) || (r.fname && String(r.fname).trim()) || (r.username && String(r.username).trim()) || (r.opd_user ? `${r.opd_user}` : "");

      if (!grouped[uhid]) {
        grouped[uhid] = {
          opd_id: r.opd_id,
          opd_uhid: r.opd_uhid,
          opd_patient_name: r.opd_patient_name,
          opd_patient_mobile: r.opd_patient_mobile,
          opd_concult_doctor: r.opd_concult_doctor,
          total_final_amt: finalAmt,
          total_paid: paid,
          total_due: Number(r.opd_due ?? 0),
          payment_mode_sample: r.opd_mode ?? r.opd_pay_mode ?? r.opd_payment_mode ?? '',
          user_display: userDisplaySample,
          user_id_sample: r.last_used_id ?? r.user_id ?? r.opd_user ?? '',
          regFee_sample: regFee,
          docFee_sample: drFee,
          __firstRow: r
        };
      } else {
        grouped[uhid].total_final_amt += finalAmt;
        grouped[uhid].total_paid += paid;
        grouped[uhid].total_due = Math.max(0, grouped[uhid].total_due + Number(r.opd_due ?? 0));
        if (!grouped[uhid].user_display) grouped[uhid].user_display = userDisplaySample;
        if (!grouped[uhid].user_id_sample) grouped[uhid].user_id_sample = r.last_used_id ?? r.user_id ?? r.opd_user ?? grouped[uhid].user_id_sample;
        if (!grouped[uhid].regFee_sample) grouped[uhid].regFee_sample = regFee;
        if (!grouped[uhid].docFee_sample) grouped[uhid].docFee_sample = drFee;
        if (!grouped[uhid].regDatetime_sample) grouped[uhid].regDatetime_sample = regDatetimeSample;
      }
    });
    return Object.values(grouped);
  };

  const filteredList = useMemo(() => {
    let list = [...masterList];
    if (formData.selectedDoctorId) {
      list = list.filter(r => String(r.opd_concult_doctor || r.opd_refer_doctor || "") === String(formData.selectedDoctorId));
    }
    if (formData.selectedUserId && String(formData.selectedUserId).trim() !== "") {
      const su = String(formData.selectedUserId);
      list = list.filter(r => {
        const uidCandidates = [r.last_used_id, r.user_id, r.opd_user].map(x => x ? String(x) : "");
        if (uidCandidates.includes(su)) return true;
        if ((r.last_used && String(r.last_used) === su) || (r.fname && String(r.fname) === su)) return true;
        return false;
      });
    }
    const grouped = groupByUHID(list);
    if (formData.search_key && formData.search_key.trim() !== "") {
      const sk = formData.search_key.toLowerCase();
      return grouped.filter(g =>
        (`${g.opd_uhid || ''}`).toLowerCase().includes(sk) ||
        (`${g.opd_patient_name || ''}`).toLowerCase().includes(sk) ||
        (`${g.opd_patient_mobile || ''}`).toLowerCase().includes(sk)
      );
    }
    return grouped;
  }, [masterList, formData.search_key, formData.selectedDoctorId, formData.selectedUserId]);

  // totals effect - NOW includes procedure bill totals
  useEffect(() => {
    let cash = 0, card = 0, online = 0, regCharges = 0, docFees = 0, paid = 0, due = 0;
    let procBillAmount = 0, procBillCash = 0, procBillCard = 0, procBillOnline = 0;

    filteredList.forEach(row => {
      const rec = row.__firstRow || {};
      regCharges += Number(row.regFee_sample ?? rec.opd_reg_fees ?? 0);
      paid += Number(row.total_paid || 0);
      due += Number(row.total_due || 0);

      const mode = classifyMode(row.payment_mode_sample || rec.opd_mode || '');
      if (mode === "cash") cash += Number(row.total_paid || 0);
      else if (mode === "card") card += Number(row.total_paid || 0);
      else if (mode === "online") online += Number(row.total_paid || 0);

      docFees += Number(row.docFee_sample ?? rec.opd_fees ?? 0);

      // Procedure bill totals from backend
      procBillAmount += Number(rec.procedure_bill_amount ?? 0);
      procBillCash += Number(rec.procedure_bill_cash ?? 0);
      procBillCard += Number(rec.procedure_bill_card ?? 0);
      procBillOnline += Number(rec.procedure_bill_online ?? 0);
    });

    paymentsList.forEach(p => {
      const amt = Number(p.opd_due_pay_amount || 0);
      const pm = classifyMode(p.opd_due_pay_mode || '');
      if (pm === "cash") cash += amt;
      else if (pm === "card") card += amt;
      else if (pm === "online") online += amt;
      else cash += amt;
      paid += amt;
    });

    setTotals(prev => ({
      ...prev,
      totalAmount: Number(filteredList.reduce((s, r) => s + Number(r.__firstRow?.opd_final_amt ?? r.total_final_amt ?? 0) + Number(r.__firstRow?.procedure_bill_amount ?? 0), 0)).toFixed(2),
      paidAmount: Number(paid).toFixed(2),
      dueAmount: Number(due).toFixed(2),
      cashTotal: Number(cash).toFixed(2),
      cardTotal: Number(card).toFixed(2),
      onlineTotal: Number(online).toFixed(2),
      registrationCharges: Number(regCharges).toFixed(2),
      doctorFees: Number(docFees).toFixed(2),
      totalRows: filteredList.length,
      procBillAmount: Number(procBillAmount).toFixed(2),
      procBillCash: Number(procBillCash).toFixed(2),
      procBillCard: Number(procBillCard).toFixed(2),
      procBillOnline: Number(procBillOnline).toFixed(2)
    }));
  }, [filteredList, paymentsList]);

  // React Select options
  const doctorOptions = useMemo(() => {
    const opts = [{ value: "all", label: "All Doctors" }];
    if (doctorsMap && typeof doctorsMap === 'object') {
      Object.entries(doctorsMap)
        .filter(([k, v]) => k && String(k).trim() !== "" && String(v).trim() !== "")
        .sort((a, b) => String(a[1]).localeCompare(String(b[1])))
        .forEach(([key, label]) => {
          opts.push({ value: key, label });
        });
    }
    return opts;
  }, [doctorsMap]);

  const userOptions = useMemo(() => {
    const opts = [{ value: "all", label: "All Users" }];
    usersList.forEach(u => {
      opts.push({ value: String(u.user_id), label: `${u.name} #${u.user_id}` });
    });
    return opts;
  }, [usersList]);

  // React Select custom styles to match bootstrap form-control
  const reactSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '38px',
      borderColor: '#ced4da',
      boxShadow: 'none',
      '&:hover': { borderColor: '#86b7fe' }
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : 'white',
      color: state.isSelected ? 'white' : '#212529',
      fontSize: '14px'
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '14px'
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '14px'
    })
  };

  // DataTable columns
  const columns = useMemo(() => [
    { name: "#", selector: (row,i) => i+1, width: "60px" },
    { name: "UHID", selector: row => row.opd_uhid || "", sortable: true, width: '200px' },
    { name: "Patient", selector: row => `${row.opd_patient_name || ''}`, cell: row => (<div>{row.opd_patient_name}<br/><small className="text-muted">{row.opd_patient_mobile}</small></div>), wrap:true, width: '200px'},
    { 
      name: 'Consult Doctor',
      selector: row => row.consult_doctor_name || getDoctorNameById(row.opd_concult_doctor),
      sortable: true,
      wrap: true,
      width: '230px'
    },
    {
      name: "User",
      selector: row => row.user_display || (row.__firstRow && (row.__firstRow.last_used || row.__firstRow.fname)) || "",
      width: "160px",
      cell: row => {
        const uid = row.__firstRow?.last_used_id ?? row.user_id_sample ?? row.__firstRow?.user_id ?? "";
        const nameFromRow = row.user_display || row.__firstRow?.last_used || row.__firstRow?.fname || "";
        const uname = (nameFromRow && String(nameFromRow).trim() !== "") ? nameFromRow : (uid ? getUserNameById(uid) : "");
        return <div>{uname}<br/></div>;
      }
    },
    { name: "Total", selector: row => Number(row.total_final_amt||0).toFixed(2), sortable:true, right:true },
    { name: "Paid", selector: row => Number(row.total_paid||0).toFixed(2), sortable:true, right:true },
    { name: "Due", selector: row => Number(row.total_due||0).toFixed(2), sortable:true, right:true },
    { name: "Payment Type", selector: row => mapPayMode(row.__firstRow?.opd_mode || row.__firstRow?.opd_pay_mode || row.payment_mode_sample || ""), width: "140px" },
    {
      name: "Date",
      selector: row => { const dt = parseServerDate(row.regDatetime_sample || row.__firstRow?.reg_datetime_display || row.__firstRow?.opd_reg_datetime || row.__firstRow?.opd_reg_date || ""); return dt ? dt.getTime() : 0; },
      sortable:true,
      cell: row => { const dt = parseServerDate(row.regDatetime_sample || row.__firstRow?.reg_datetime_display || row.__firstRow?.opd_reg_datetime || row.__firstRow?.opd_reg_date || ""); return dt ? formatDateTime12h(dt) : ""; },
      width: "230px"
    }
  ], [formData.docs, usersList]);

  // Print
  function generatePrintHtml(list, payments, totalsForFooter) {
    const style = `
      <style>
        body{font-family: Arial, Helvetica, sans-serif; padding: 20px; color: #222;}
        table{border-collapse: collapse; width:100%; margin-top:10px;}
        th, td{border:1px solid #ccc; padding:6px 8px; text-align:left; font-size:12px;}
        th{background:#f2f2f2;}
        .footer-summary{margin-top:12px; font-size:13px;}
      </style>
    `;
    const rowsHtml = list.map((r,i) => {
      const rec = r.__firstRow || {};
      const docId = rec.opd_concult_doctor ?? r.opd_concult_doctor;
      const docName = rec.opd_concult_doctor_name || rec.opd_refer_doctor_name || getDoctorNameById(docId) || "";
      const uid = rec.last_used_id ?? r.user_id_sample ?? rec.user_id ?? "";
      const uname = r.user_display || rec.last_used || rec.fname || getUserNameById(uid);
      return `<tr><td>${i+1}</td><td>${r.opd_uhid||''}</td><td>${r.opd_patient_name||''}</td><td>${docName}</td><td>${uname}</td><td style="text-align:right">${Number(r.total_final_amt||0).toFixed(2)}</td></tr>`;
    }).join('');
    const footerHtml = `
      <div class="footer-summary">
        <div><strong>Total Amount:</strong> ${totalsForFooter.totalAmount}</div>
        <div><strong>Total Registration Charges:</strong> ${totalsForFooter.registrationCharges}</div>
        <div><strong>Total Doctor Fees:</strong> ${totalsForFooter.doctorFees}</div>
        <div><strong>Cash Paid:</strong> ${totalsForFooter.cashTotal} &nbsp;|&nbsp; <strong>Card Paid:</strong> ${totalsForFooter.cardTotal} &nbsp;|&nbsp; <strong>Online Paid:</strong> ${totalsForFooter.onlineTotal}</div>
        <div><strong>Paid Total:</strong> ${totalsForFooter.paidAmount} &nbsp;|&nbsp; <strong>Due Total:</strong> ${totalsForFooter.dueAmount}</div>
        <div style="margin-top:8px; border-top:1px solid #ccc; padding-top:8px;">
          <strong>Procedure Bill Amount:</strong> ${totalsForFooter.procBillAmount} &nbsp;|&nbsp;
          <strong>Proc Cash:</strong> ${totalsForFooter.procBillCash} &nbsp;|&nbsp;
          <strong>Proc Card:</strong> ${totalsForFooter.procBillCard} &nbsp;|&nbsp;
          <strong>Proc Online:</strong> ${totalsForFooter.procBillOnline}
        </div>
      </div>
    `;
    return `
      <!doctype html>
      <html>
        <head><meta charset="utf-8" /><title>OPD Reports Print</title>${style}</head>
        <body>
          <h2>OPD Reports</h2>
          <div>Generated on: ${new Date().toLocaleString()}</div>
          <h3 style="margin-top:14px;">Registrations</h3>
          <table>
            <thead><tr><th>#</th><th>UHID</th><th>Name</th><th>Doctor</th><th>User</th><th>Total</th></tr></thead>
            <tbody>${rowsHtml}</tbody>
          </table>
          ${footerHtml}
        </body>
      </html>
    `;
  }

  function handleExportPDF() {
    const rows = filteredList || [];
    const payments = paymentsList || [];
    const footerTotals = {
      totalAmount: totals.totalAmount,
      registrationCharges: totals.registrationCharges || 0,
      doctorFees: totals.doctorFees || 0,
      cashTotal: totals.cashTotal || 0,
      cardTotal: totals.cardTotal || 0,
      onlineTotal: totals.onlineTotal || 0,
      paidAmount: totals.paidAmount || 0,
      dueAmount: totals.dueAmount || 0,
      procBillAmount: totals.procBillAmount || 0,
      procBillCash: totals.procBillCash || 0,
      procBillCard: totals.procBillCard || 0,
      procBillOnline: totals.procBillOnline || 0
    };
    const html = generatePrintHtml(rows, payments, footerTotals);
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow?.document || iframe.contentDocument || iframe.document;
    if (!doc) { toast.error("Unable to create print frame."); document.body.removeChild(iframe); return; }
    doc.open(); doc.write(html); doc.close();
    iframe.onload = () => {
      try { iframe.contentWindow.focus(); setTimeout(()=>{ try{ iframe.contentWindow.print(); } catch(e){ toast.error("Print failed"); } finally { setTimeout(()=>{ try{ document.body.removeChild(iframe); }catch(e){} },500); } },300); } catch(e){ console.error(e); toast.error("Print failed"); try{ document.body.removeChild(iframe);}catch(_){} }
    };
    setTimeout(() => {
      if (document.body.contains(iframe)) {
        try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch(e){} finally { setTimeout(()=>{ try{ document.body.removeChild(iframe);}catch(_){} },500); }
      }
    }, 800);
  }

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px',
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',
        lineHeight: '55px'
      }
    },
  };

  // UI
  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Summary cards */}
        <div className="row mb-6">
          <div className="col-md-6"><div className="card p-3"><p className="mb-1 text-muted"> <div
            className="bg-light-success rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ width: 50, height: 50 }}
          >
            <i className="bi bi-currency-rupee" style={{ fontSize: 26, color: "#198754" }} />
          </div>Total Patients</p><h4 className="mb-0" style={{ color: "#14532d" }}>{summary.totalReports}</h4></div></div>
          <div className="col-md-6"><div className="card p-3"><p className="mb-1 text-muted"> <div
            className="bg-light-success rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ width: 50, height: 50 }}
          >
            <i className="bi bi-currency-rupee" style={{ fontSize: 26, color: "#198754" }} />
          </div>Total Amount</p><h4 className="mb-0" style={{ color: "#14532d" }}>{Number(summary.totalAmount||0).toFixed(2)}</h4></div></div>
        </div>

        {/* Filters */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-md-3"><label>Search (UHID / Name / Mobile)</label><input className="form-control" name="search_key" value={formData.search_key} onChange={handleChange} placeholder="Search by name, UHID"/></div>
              <div className="col-md-2"><label>From</label><input className="form-control" type="date" name="from" value={formData.from} onChange={handleChange} /></div>
              <div className="col-md-2"><label>To</label><input className="form-control" type="date" name="to" value={formData.to} onChange={handleChange} /></div>
              <div className="col-md-3">
                <label>Doctor</label>
                <Select
                  options={doctorOptions}
                  value={doctorOptions.find(o => o.value === (formData.selectedDoctorId || "all")) || doctorOptions[0]}
                  onChange={(selected) => {
                    const val = selected?.value === "all" ? "" : (selected?.value || "");
                    setFormData(prev => ({ ...prev, selectedDoctorId: val }));
                  }}
                  styles={reactSelectStyles}
                  isSearchable={true}
                  placeholder="Select Doctor..."
                />
              </div>

              <div className="col-md-2">
                <label>User</label>
                <Select
                  options={userOptions}
                  value={userOptions.find(o => o.value === (formData.selectedUserId || "all")) || userOptions[0]}
                  onChange={(selected) => {
                    const val = selected?.value === "all" ? "" : (selected?.value || "");
                    setFormData(prev => ({ ...prev, selectedUserId: val }));
                  }}
                  styles={reactSelectStyles}
                  isSearchable={true}
                  placeholder="Select User..."
                />
              </div>

              <div className="col-md-2 d-flex align-items-end">
                <button className="btn btn-secondary" onClick={()=>{ setFormData(prev=>({...prev, search_key:'', from: today, to: today, selectedDoctorId: '', selectedUserId: ''})); }}>Clear</button>
              </div>
            </div>
          </div>
        </div>

        {/* Table & export */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2"><div/> <div><button className="btn btn-outline-primary" onClick={handleExportPDF}>Export / Print</button></div></div>
            <DataTable columns={columns} data={filteredList} customStyles={customStyles} pagination highlightOnHover dense persistTableHead responsive />

            {/* Footer totals - OPD */}
            <div className="d-flex justify-content-end mt-3">
              <div className="text-muted">
                <strong>Total Amount:</strong> {totals.totalAmount} &nbsp;|&nbsp;
                <strong>Total Reg Charges:</strong> {totals.registrationCharges} &nbsp;|&nbsp;
                <strong>Total Doctor Fees:</strong> {totals.doctorFees} &nbsp;|&nbsp;
                <strong>Cash Paid:</strong> {totals.cashTotal} &nbsp;|&nbsp;
                <strong>Card Paid:</strong> {totals.cardTotal} &nbsp;|&nbsp;
                <strong>Online Paid:</strong> {totals.onlineTotal} &nbsp;|&nbsp;
                <strong>Paid:</strong> {totals.paidAmount} &nbsp;|&nbsp;
                <strong>Due:</strong> {totals.dueAmount} &nbsp;|&nbsp;
                <strong>Total Patient:</strong> {totals.totalRows}
              </div>
            </div>

            {/* Footer totals - Procedure Bills */}
            <div className="d-flex justify-content-end mt-2">
              <div className="text-muted" style={{ borderTop: '1px solid #dee2e6', paddingTop: '8px' }}>
                <strong>Procedure Bill Amount:</strong> {totals.procBillAmount} &nbsp;|&nbsp;
                <strong>Proc Cash:</strong> {totals.procBillCash} &nbsp;|&nbsp;
                <strong>Proc Card:</strong> {totals.procBillCard} &nbsp;|&nbsp;
                <strong>Proc Online:</strong> {totals.procBillOnline}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OpdReports;